<template>
  <div class="hl-pop-wrap">
    <div class="hl-pop-content">
      <div class='tips'>
        <div class="hl-pop-title" v-html="title" v-if="title"></div>
        <i class="el-icon-close close" @click="close(1)" v-if="isCloseIcon"></i>
      </div>
      <div v-if='title=="流程重启"' class='form'>
        <el-form label-width='80px' label-position='right' :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label='原因' prop='resone'>
            <el-input type="textarea" ref='input' v-model="ruleForm.resone" :autosize="{ minRows: 5}" style='width:330px' maxlength="300" show-word-limit></el-input>
            
          </el-form-item>
          <span style='font-size:12px;color:red;margin-left:80px'>重启后，流程将回到发起申请环节，发起人可以编辑或删除。</span>
        </el-form>
        
      </div>
      <div class="hl-pop-detail" v-else>
        <i class='el-icon-warning warning'></i>
        <div>
          <div v-html="message" v-if="message" class="hl-pop-message"></div>
          <div v-html="subMessage" v-if="subMessage" class="hl-pop-submessage"></div>
        </div>
      </div>
      <div class="hl-alert-btn-group">
        <el-button type="primary" size="small" style='width:80px' @click="ensure">{{ensureBtnText}}</el-button>
        <el-button  size="small"  style='width:80px' @click="close(2)">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      ruleForm:{
        resone:''
      },
      rules:{
        resone:[{ required: true, message: '请输入原因', trigger: 'blur' }]
      }
    }
  },
  created(){
    this.$nextTick(()=>{
      this.$refs.input&&this.$refs.input.resizeTextarea()
    })
  },
  methods: {
    ensure () {
      if(this.title == '流程重启'){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.ensureHanlder(this.ruleForm.resone)
            this.$el.parentNode.removeChild(this.$el)
          } 
        });
      }else{
        this.ensureHanlder()
        this.$el.parentNode.removeChild(this.$el)
      }
    },
    close (mode) {
      mode === 2 && this.cancelHandler()
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>
<style lang="scss">
.hl-pop-wrap{
  position: fixed;
  top: 0;
  left: 0;
  background: #000;
  bottom: 0;
  right: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  .hl-pop-content{
    width: 480px;
    min-height: 180px;
    background: #fff;
    margin:auto;
    margin-top:calc(15vh);
    // padding:0 20px 20px;
    .tips{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height:50px;
      padding:0 20px 10px;
      .close{
        cursor: pointer;
      }
    }
    .form{
      padding:20px 0;
      border-top:1px solid #eee;
    }
    .hl-pop-detail{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 40px;
      .warning{
        font-size: 40px;
        color: red;
        margin-right: 10px;
      }
      .hl-pop-message,.hl-pop-submessage{
        font-size: 16px;
      }
    }
  }
  .hl-alert-btn-group{
    display: flex;
    justify-content: center;
    align-content: center;
    padding:20px;
    border-top: 1px solid #eee;
  }
  .el-form-item__label{
    text-align: right;
  }
  // .el-form-item{
  //   margin-bottom: 0;
  // }
}
</style>


// WEBPACK FOOTER //
// XmDialog.vue?2e232fec